import React, { Component } from 'react';
import Pokegame from './Pokegame';
// import './App.css';

class App extends Component {
    render() {
        return(
            <div clssName='App'>
                <Pokegame />
            </div>
        );
    }
}

export default App;